<template>
	<div>
		<div :style="progressBarStateLabelStyle"></div>
		<div class="section">
			<div
				class="box"
				:style="boxStyle"
				v-for="state in states"
				:key="'box_key_' + state.value"
			>
				<label :class="['state-label', states[0].label === '' ? 'state-label-center' : '']">{{ state.label }}</label>
				<div class="current-state" v-if="equals(state.value)"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StepProgressBar',
	props: {
		states: {
			type: Array,
			require: true
		},
		activeValue: {
			type: [String, Number],
			require: true
		}
	},
	computed: {
		progressBarStateLabelStyle: function () {
			return {
				margin: '0.5rem 0',
				display: 'flex',
				'justify-content': 'space-around'
			}
		},
		boxStyle: function () {
			return {
				width: '50%',
				position: 'relative'
			}
		}
	},
	methods: {
		equals: function (value) {
			if (Array.isArray(value)) {
				return value.some((v) => v === this.activeValue)
			} else {
				return value === this.activeValue
			}
		}
	}
}
</script>

<style lang='scss' scoped>
.section {
	display: flex;
	background-image: url('~@/assets/image/home/motorBg.svg');
	height: 1.5rem;
    background-repeat: no-repeat;
    background-size: contain;
}
.state-label {
	position: absolute;
	color: $progressDialogHighlightTextColor;
	transform: translate(1rem, -1.5rem);
	font-size: 0.7rem;
}
.state-label-center {
    transform: translate(-1rem, -1.5rem);
}
.box {
	position: relative;
}
.current-state {
	background-image: url('~@/assets/image/home/motor.svg');
	width: 35px;
	height: 35px;
	left: 15%;
	top: -25%;
	background-repeat: no-repeat;
	position: absolute;
	background-size: contain;
}
@media screen and (min-width: 0px) and (max-width: 320px) {
	.current-state {
		left: 0%;
	}
}

@media screen and (min-width: 321px) and (max-width: 411px) {
	.current-state {
		left: 15%;
	}
}
</style>
